/* eslint-disable no-undef */
import {useEffect, useState} from 'react'
import queryString from 'query-string'
import {globalHistory} from '@reach/router'

const useParams = () => {
  const [parsedQs, setParsedQsString] = useState({})

  useEffect(() => {
    setParsedQsString(queryString.parse(window.location.search))

    globalHistory.listen(({action}) => {
      if (action === 'PUSH') setParsedQsString(queryString.parse(window.location.search))
    })
  }, [])

  return parsedQs
}

export default useParams
